import SEO from "../components/SEO.js"
import { getContactPointSchema } from "../utils/structuredData.js"

const ContactPage = ({ text }) => {
    // Contact point structured data
    const contactPointData = getContactPointSchema({
        telephone: '+390472840030',
        contactType: 'customer service',
        areaServed: 'IT',
        availableLanguage: ['German', 'Italian', 'English'],
        url: 'https://www.drockerhof.it/contact'
    })

    // Schema.org structured data for the farm
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "LodgingBusiness",
        "name": "Drockerhof",
        "image": "https://www.drockerhof.it/assets/images/drockerhof_entrance_1.jpg",
        "priceRange": "$$",
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "San Giacomo 18",
            "addressLocality": "Funes",
            "addressRegion": "South Tyrol",
            "postalCode": "39040",
            "addressCountry": "IT"
        },
        "geo": {
            "@type": "GeoCoordinates",
            "latitude": 46.65406102851609,
            "longitude": 11.650029741684827
        },
        "telephone": "+390472840030",
        "email": "info@drockerhof.it",
        "url": "https://www.drockerhof.it",
        "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
                "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
            ],
            "opens": "08:00",
            "closes": "20:00"
        }
    }

    return (
        <>
            <SEO
                title={text.contactTitle}
                description={text.contactAddress}
                structuredData={[schemaData, contactPointData]}
                alternateUrls={[
                    { lang: 'de', url: 'https://www.drockerhof.it/de/contact' },
                    { lang: 'it', url: 'https://www.drockerhof.it/it/contact' },
                    { lang: 'en', url: 'https://www.drockerhof.it/en/contact' }
                ]}
            />
            <div className="drocker-body drocker-no-image">
                <div className="container">
                    <h1>{text.contactTitle}</h1>
                    <address>
                        <p dangerouslySetInnerHTML={{ __html: text.contactAddress }} />
                    </address>
                    <p>
                        {text.contactTelephone}: <a href="tel:+390472840030" target="_blank" rel="noreferrer" aria-label="Call us at +39 0472 840 030">+39 0472 840 030</a><br />
                        WhatsApp: <a href={`https://wa.me/+393420302036?text=${text.whatsappMessage}`} target="_blank" rel="noreferrer" aria-label="Contact us on WhatsApp at +39 342 030 2036">+39 342 030 2036</a><br />
                        Email: <a href="mailto:info@drockerhof.it" target="_blank" rel="noreferrer" aria-label="Email us at info@drockerhof.it">info@drockerhof.it</a>
                    </p>
                </div>
            </div>
        </>
    )
}

export default ContactPage
